import React, { useState } from 'react'
import { Card, Dropdown, OverlayTrigger, Row, Tooltip } from 'react-bootstrap'
import { Col } from 'react-bootstrap'
import { BsPersonFillAdd } from 'react-icons/bs'
import { FiRefreshCcw, FiUnlock } from 'react-icons/fi'
import { RiHistoryFill } from 'react-icons/ri';
import { useUnblockUser } from '../../../../Hooks/Users/useUnblockUser'
import { GetCbuResponse } from '../../../../Api/CBU/models'
import { AdminPublicInfo } from '../../../../Api/Admin/models'
import { useHistory } from '../../../../Hooks/Coins/useHistory'
import { BiGift, BiLoaderCircle } from 'react-icons/bi';
import LocalHistoryModalUsers from './LocalHistoryModalUsers'
import { useResetUser } from '../../../../Hooks/Users/useResetUser'
import { PlayerCoinHistoryGanamosModal } from './PlayerHistory/PlayerCoinHistoryGanamosModal'
import { toast } from 'react-hot-toast'
import { PlayerCoinHistoryBluedayModal } from './PlayerHistory/PlayerCoinHistoryBluedayModal'
import { useCreateUser } from '../../../../Hooks/Users/useCreateUser'
import { PlayerGameHistoryGanamos } from './PlayerHistory/GameHistory/PlayerGameHistoryGanamos'
import { PlayerGameHistoryBlueday } from './PlayerHistory/GameHistory/PlayerGameHistoryBlueday'
import { PlayerCoinHistoryBetmoneyModal } from './PlayerHistory/PlayerCoinHistoryBetmoneyModa'
import { PlayerGameHistoryBetMoney } from './PlayerHistory/GameHistory/PlayerGameHistoryBetMoney'
import { PlayerGameHistoryGreenbet } from './PlayerHistory/GameHistory/PlayerGameHistoryGreenbet'
import { MdInfoOutline } from 'react-icons/md'
import { PlayerCoinHistoryGanaEnCasa } from './PlayerHistory/PlayerCoinHistoryGanaEnCasa'
import { PlayerGameHistoryGanaEnCasa } from './PlayerHistory/GameHistory/PlayerGameHistoryGanaEnCasa'

interface Props {
  adminInfo: AdminPublicInfo | null
  fetchedData: GetCbuResponse | null
}

export const UsersPanel = ({ adminInfo, fetchedData }: Props) => {

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [useRandomNumber, setUseRandomNumber] = useState(true)
  // Coin History Modals
  const [showPlayerCoinHistoryGanamos, setShowPlayerCoinHistoryGanamos] = useState<boolean>(false)
  const [showPlayerCoinHistoryBlueday, setShowPlayerCoinHistoryBlueday] = useState<boolean>(false)
  const [showPlayerCoinHistoryGanaEnCasa, setShowPlayerCoinHistoryGanaEnCasa] = useState<boolean>(false)

  // Betmoney History Modals
  const [showPlayerCoinHistoryBetmoney, setShowPlayerCoinHistoryBetmoney] = useState<boolean>(false)
  const [showPlayerGameHistoryBetmoney, setShowPlayerGameHistoryBetmoney] = useState<boolean>(false)

  // Game History Modals
  const [showPlayerGameHistoryGanamos, setShowPlayerGameHistoryGanamos] = useState<boolean>(false)
  const [showPlayerGameHistoryBlueday, setShowPlayerGameHistoryBlueday] = useState<boolean>(false)
  const [showPlayerGameHistoryGreenbet, setShowPlayerGameHistoryGreenbet] = useState<boolean>(false)
  const [showPlayerGameHistoryGanaEnCasa, setShowPlayerGameHistoryGanaEnCasa] = useState<boolean>(false)

  // States
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: '',
  })

  const {
    historial,
    errorQuantities,
    setHistorial,
    setErrorQuantities,
    showHistory,
    setShowHistory
  } = useHistory()


  // Unblock
  const { handleUnblockUser } = useUnblockUser({
    adminInfo,
    setForm,
    setLoading,
    setDropdownOpen,
    fetchedData,
    form,
    loading,
    setHistorial,
    historial,
    setErrorQuantities,
    errorQuantities,
    showHistory,
    setShowHistory,
  })

  // Reset
  const { handleResetUser } = useResetUser({
    adminInfo,
    setForm,
    setLoading,
    setDropdownOpen,
    fetchedData,
    form,
    loading,
    setHistorial,
    historial,
    setErrorQuantities,
    errorQuantities,
    showHistory,
    setShowHistory,
  })


  // Create
  const { handleCreateUser } = useCreateUser({
    adminInfo,
    setForm,
    setLoading,
    setDropdownOpen,
    fetchedData,
    form,
    loading,
    setHistorial,
    historial,
    setErrorQuantities,
    errorQuantities,
    showHistory,
    setShowHistory,
    useRandomNumber,
  })



  // Show Player Coin History Modal
  const handleShowPlayerHistoryModal = () => {
    if (!form.name) {

      toast.error('Debe ingresar un nombre de usuario')
      return
    }

    if (adminInfo?.platform === 'ganamos') {
      setShowPlayerCoinHistoryGanamos(true)
    } else if (adminInfo?.platform === 'betmoney') {
      setShowPlayerCoinHistoryBetmoney(true)
    } else if (adminInfo?.platform === 'ganaencasa') {
      setShowPlayerCoinHistoryGanaEnCasa(true)
    } else {
      setShowPlayerCoinHistoryBlueday(true)

    }
  }

  // Show Player Game History Modal
  const handleShowPlayerGameHistoryModal = () => {
    if (!form.name) {
      toast.error('Debe ingresar un nombre de usuario')
      return
    }

    if (adminInfo?.platform === 'ganamos') {
      setShowPlayerGameHistoryGanamos(true)
    } else if (adminInfo?.platform === 'betmoney') {
      setShowPlayerGameHistoryBetmoney(true)
    } else if (adminInfo?.platform === 'greenbet') {
      setShowPlayerGameHistoryGreenbet(true)
    } else if (adminInfo?.platform === 'ganaencasa') {
      setShowPlayerGameHistoryGanaEnCasa(true)
    } else {
      setShowPlayerGameHistoryBlueday(true)

    }

  }

  const inputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  const inPromo = adminInfo?.currentlyInPromo;

  return (
    <div className='w-100'>
      <Card className='px-3 text-black pt-3 pb-2'>

        <div className="mb-1 d-flex justify-content-start text-primary px-1 w-100 text-xs text-center text-white mx-2">
          Panel de Usuarios
        </div>
        {/* Inputs */}

        <Row className='mb-2 d-flex justify-content-center g-0'>
          <Col className='mx-0 px-1'>
            <div className="input-group mb-3 d-flex align-items-center">
              <input value={form.name} onChange={inputHandler} name='name' type="text" className="form-control" placeholder="Usuario" aria-label="Recipient's username" aria-describedby="basic-addon2" />
              {inPromo &&
                <button onClick={() => handleCreateUser({ createdInPromo: true })} className="btn bg-primaryy text-white rounded-end mx-1 py-0 my-0 border-0 d-flex align-items-center justify-content-center" type="submit" style={{ height: '35px' }}>
                  {loading ? <BiLoaderCircle size={18} /> : <BiGift size={20} className='p-0 m-0' />}
                </button>
              }

              <button onClick={() => handleCreateUser({ createdInPromo: false })}
                className={`btn bg-primaryy text-white py-0 my-0 border-0 d-flex align-items-center justify-content-center ${inPromo ? 'rounded' : 'rounded-start-0'}`}
                type="submit"
                style={{ height: '35px' }}>
                {loading ? <BiLoaderCircle size={18} /> : <BsPersonFillAdd size={20} className='p-0 m-0' />}
              </button>

            </div>
          </Col>

        </Row>

        <Row className='mb-2 d-flex justify-content-center g-0 mt-2'>

          <Col className='action-button p-2 mx-1 rounded d-flex'>
            <div onClick={handleUnblockUser} className='w-100 d-flex flex-column align-items-center gap-2'>
              {loading ? <BiLoaderCircle size={18} /> : <FiUnlock size={18} />}
              <Row className='d-flex justify-content-center'>
                <span className='text-center'>Desbloquear</span>


              </Row>
            </div>
          </Col>

          <Col className='action-button p-2 mx-1 rounded d-flex'>
            <div onClick={handleResetUser} className='w-100 d-flex flex-column align-items-center gap-2'>
              {loading ? <BiLoaderCircle size={18} /> : <FiRefreshCcw size={18} />}
              <Row className='d-flex justify-content-center'>
                <span className='text-center'>Reestablecer</span>
              </Row>

            </div>
          </Col>

          <Col className='action-button p-2 mx-1 rounded d-flex'>
            <div onClick={() => setDropdownOpen(!dropdownOpen)} className='w-100 d-flex flex-column align-items-center gap-2'>
              {loading ? <BiLoaderCircle size={18} /> : <RiHistoryFill size={18} />}
              <Row className='d-flex justify-content-center'>
                <span className='text-center'>Historial de Cargas</span>
              </Row>
            </div>
            <Dropdown show={dropdownOpen}>
              <Dropdown.Menu className='dark-dropdown-custom'>
                <Dropdown.Item className="text-secondary" onClick={handleShowPlayerHistoryModal} >Historial de cargas</Dropdown.Item>
                <Dropdown.Item className="text-secondary" onClick={handleShowPlayerGameHistoryModal}>Historial de juego</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
          <div className='w-100 d-flex flex-end justify-content-start mx-2 mt-4 align-items-center gap-2 mx-1 rounded'>
            <div className='form-check w-100 mx-2'>
              <input
                className='form-check-input'
                type='checkbox'
                id='useRandomNumberCheck'
                checked={useRandomNumber}
                onChange={() => setUseRandomNumber(!useRandomNumber)}
              />
              <label className='form-check-label text-secondary' htmlFor='useRandomNumberCheck'>
                Agregar número aleatorio al crear usuario ({useRandomNumber ? 'Activo' : 'Inactivo'})
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip>Si está activo, se agregará un número aleatorio del 1 al 99 al crear un usuario.</Tooltip>}
                >
                  <MdInfoOutline size={20} className="text-secondary mx-1" />
                </OverlayTrigger>

              </label>
            </div>
          </div>

        </Row>

        {historial?.length > 0 &&
          <div className='text-end text-secondary mx-2 text-xxs text-primary' role='button' onClick={() => setShowHistory(!showHistory)}>
            {errorQuantities > 0 ? <span className='text-danger'>{errorQuantities} transacciones con errores</span> : ''} Mostrar Historial
          </div>
        }

        {showHistory &&
          <LocalHistoryModalUsers
            historial={historial}
            show={showHistory}
            onHide={() => setShowHistory(false)}
            setErrorQuantities={setErrorQuantities}
          />
        }


        {showPlayerCoinHistoryGanamos &&
          <PlayerCoinHistoryGanamosModal
            show={showPlayerCoinHistoryGanamos}
            onHide={() => setShowPlayerCoinHistoryGanamos(false)}
            form={form}
          />
        }

        {showPlayerCoinHistoryBlueday &&
          <PlayerCoinHistoryBluedayModal
            show={showPlayerCoinHistoryBlueday}
            onHide={() => setShowPlayerCoinHistoryBlueday(false)}
            form={form}
          />
        }

        {showPlayerGameHistoryGanamos &&
          <PlayerGameHistoryGanamos
            show={showPlayerGameHistoryGanamos}
            onHide={() => setShowPlayerGameHistoryGanamos(false)}
            form={form}
          />
        }

        {showPlayerGameHistoryBlueday &&
          <PlayerGameHistoryBlueday
            show={showPlayerGameHistoryBlueday}
            onHide={() => setShowPlayerGameHistoryBlueday(false)}
            form={form}
          />
        }

        {showPlayerCoinHistoryBetmoney &&
          <PlayerCoinHistoryBetmoneyModal
            show={showPlayerCoinHistoryBetmoney}
            onHide={() => setShowPlayerCoinHistoryBetmoney(false)}
            form={form}
          />
        }

        {showPlayerGameHistoryBetmoney &&
          <PlayerGameHistoryBetMoney
            show={showPlayerGameHistoryBetmoney}
            onHide={() => setShowPlayerGameHistoryBetmoney(false)}
            form={form}
          />
        }

        {showPlayerGameHistoryGreenbet &&
          <PlayerGameHistoryGreenbet
            show={showPlayerGameHistoryGreenbet}
            onHide={() => setShowPlayerGameHistoryGreenbet(false)}
            form={form}
          />
        }
        {showPlayerGameHistoryGanaEnCasa &&
          <PlayerGameHistoryGanaEnCasa
            show={showPlayerGameHistoryGanaEnCasa}
            onHide={() => setShowPlayerGameHistoryGanaEnCasa(false)}
            form={form}
          />
        }

        {showPlayerCoinHistoryGanaEnCasa &&
          <PlayerCoinHistoryGanaEnCasa
            show={showPlayerCoinHistoryGanaEnCasa}
            onHide={() => setShowPlayerCoinHistoryGanaEnCasa(false)}
            form={form}
          />
        }
      </Card>
    </div >

  )



}
